module.exports = __webpack_public_path__ + "img/info_icon.fdb272bd.svg";